import { createContext } from 'react';

export const ribbonSliderAlignments = {
  right: ['left', 'right', 'top'],
  'right-down': ['left', 'right', 'top'],
  'right-center': ['left', 'right', 'top', '0%, -50%'],
  'right-up': ['left', 'right', 'bottom'],
  left: ['right', 'left', 'top'],
  'left-down': ['right', 'left', 'top'],
  'left-center': ['right', 'left', 'top', '0%, -50%'],
  'left-up': ['right', 'left', 'bottom'],
  'down-left': ['top', 'bottom', 'right'],
  'down-center': ['top', 'bottom', 'right', '50%, 0%'],
  'down-right': ['top', 'bottom', 'left'],
  down: ['top', 'bottom', 'left'],
  'up-left': ['bottom', 'top', 'right'],
  'up-center': ['bottom', 'top', 'right', '50%, 0%'],
  'up-right': ['bottom', 'top', 'left'],
  up: ['bottom', 'top', 'left'],
};

export type RibbonSliderAlignment = keyof typeof ribbonSliderAlignments;

export interface RibbonButtonSliderContextType {
  autoClose: boolean | undefined;
  menuUniqueId: string;
  positionAnchor: string;
}

export const RibbonButtonSliderContext = createContext<RibbonButtonSliderContextType>({
  autoClose: undefined,
  menuUniqueId: '',
  positionAnchor: '',
});
